import { h, Fragment } from "preact"; /** @jsx h */

import { timestampStringInEnglish } from '@pyqml/shared';
import { Page, Paywalled } from "@pyqml/model";
import { ICategory } from '@pyqml/model';
import { ROUTES } from '@pyqml/shared';

import { useEnvironment } from "../app/Environment";

import { Header, IHeaderProps } from "../components/Header";


import { Layout } from '../components/Layout';
import { List } from '../components/List';
import { Subheader } from '../components/Subheader';

import { ArticleProvider } from "../provider/ArticleProvider";
import { Content } from "../components/Content";
import { ContentItem } from "../components/ContentItem";
import { BlogCover } from "../components/BlogCover";




export type IPassageProps = {
	draft: boolean | undefined;
    
} & IHeaderProps;



export const Passage = (props: IPassageProps) => {
    const { baseUrl, subdomain } = useEnvironment();

    return <ArticleProvider draft={props.draft} usePassage={true} >
    {
        // @ts-ignore
        (article: Page.IPage, paywalled: Paywalled.IPaywalled) => {
            
            //const pagesInCategory = pages?.filter?.(page => page.category === article?.category && page.slug !== article?.slug);
            //const pagesNotInCategory = pages?.filter?.(page => page.category !== article?.category);
            console.log("loaded Passage: ", article);
            //console.log("paywalled", paywalled)
            
            return (
                <Layout.Stacked>
                    <Fragment as="Section">
                        <BlogCover  title={article?.title ?? "Loading"} subtitle={article?.subtitle || ""} />
                        
                        
                    </Fragment>
                    <Layout.Section weight="full">
                        {
                            article?.categories?.filter(category => !(!category)).map((category: ICategory) => (
                                <a
                                    className="text-danger mr-2"
                                    href={`${baseUrl}${ROUTES.BLOG_CATEGORY}/${category.categorySlug}`}
                                    
                                >
                                    { category.categoryName }
                                </a>
                            ))
                        }
                        { article?.abstractImage && <div className="col-12 pr-0">
                            <img src={ `/${subdomain}/${article.abstractImage}`} className="w-100 pt-3"></img>
						</div> }
                    </Layout.Section>

                    
                    <Layout.Section weight="full">
                        <Content >
                            <ContentItem contentId={"contentElement"} text={article?.content ?? ""} paywalled={paywalled?.paywalledContent ?? ""} />
                            
                        
                        </Content>
                    
                    </Layout.Section>
                    
                    {/**
                     * 
                     * 
                    <Layout.Section weight="equal">
                        <Subheader title="Read next" />
                        <Layout.Column>
                        {
                            pagesInCategory && <List.Promoted>{
                                pagesInCategory?.map((page: Page.IPage) => (
                                    <List.Item
                                        title={ page.title }
                                        abstract={ page.abstract }
                                        image={ page.abstractImage}
                                        linkTo={ page.slug }
                                        authorLinkTo="./frank"
                                        authorName="Dr. Frank Zickert"
                                        publishedAt={ timestampStringInEnglish(page.revision) }
                                        readingTime={ page.readingTime ?? undefined }
                                    />
                                ))
                            }</List.Promoted>
                        }
                        </Layout.Column>
                        <Layout.Column>
                        {
                            pagesNotInCategory && <List.Compact>{
                                pagesNotInCategory?.map((page: Page.IPage) => (
                                    <List.Item
                                        title={ page.title }
                                        abstract={ page.abstract }
                                        image={ page.abstractImage}
                                        linkTo={ page.slug }
                                        authorLinkTo="./frank"
                                        authorName="Dr. Frank Zickert"
                                        publishedAt={ timestampStringInEnglish(page.revision) }
                                        readingTime={ page.readingTime ?? undefined }
                                    />
                                ))
                            }</List.Compact>
                        }
                        </Layout.Column>
                    
                    </Layout.Section>
                     */}
                </Layout.Stacked>

            )
        }
    }
    </ArticleProvider>
}
